import React, {
  useEffect,
  useState
} from "react";

import {
  Link
} from "react-router-dom";
import { getCategories, getProducts } from "../pages/publicservice/productService";
import { Category } from "../pages/publicservice/interface/types";

const API_PATH = process.env.REACT_APP_API_PATH;

const FALLBACK_IMAGE = "/assets/img/categories/cate-1-1.jpg";

const CategoriesSection: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);

  const [loading, setLoading] = useState(true);

  // ==========================================
  // LOAD CATEGORIES
  // ==========================================

  useEffect(() => {

    loadCategories();

  }, []);


  async function loadCategories() {

    try {

      setLoading(true);

      const res =
        await getCategories();

      setCategories(res.dataList || []);

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);
    }
  }

  // ==========================================
  // IMAGE ERROR
  // ==========================================

  function handleImageError(
    e: React.SyntheticEvent<HTMLImageElement>
  ) {
    e.currentTarget.src =
      FALLBACK_IMAGE;
  }

  const getProductImage = (product: Category) => {
    const imagePath = product?.categoryImage;
    // fallback image
    if (!imagePath) {
      return "/assets/img/products/product-1-1.jpg";
    }
    // full image url
    return `${API_PATH}/uploads/${imagePath}`;
  };

  return (
    <section className="cate-layout1 space space-extra-bottom z-index-common" data-bg-src="/assets/img/categories/cate-bg-1-1.png">
      <div className="container">
        <div className="row align-items-center gy-40">

          {/* LEFT: Image */}
          <div className="col-lg-4 d-none d-lg-block">
            <div className="cate-left-imgbox">
              <img src="/assets/img/categories/cate-main-1-1.jpg" alt="earring" className="cate-left-img" onError={handleImageError} />
              <div className="cate-left-caption">
                <span>Earring</span>
              </div>
            </div>
          </div>

          {/* RIGHT: Title + Cards */}
          <div className="col-lg-8">
            <div className="ps-lg-4">
              <div className="title-area mb-40">
                <span className="sec-subtitle">exclusive collection</span>
                <h2 className="sec-title">SHOP BY CATEGORY</h2>
                <img src="/assets/img/shapes/title-shape-2.svg" alt="title shape" onError={handleImageError} />
              </div>
              {/* LOADING */}
              {loading && (
                <div className="text-center py-5">
                  Loading categories...
                </div>
              )}
              {/* EMPTY */}
              {!loading &&
                categories.length === 0 && (
                  <div className="text-center py-5">
                    No categories found
                  </div>
                )}

              <div className="row">
                {categories.map((cat, i) => (
                  <div key={i} className="col-4">
                    <div className="cate-style1">
                      <div className="cate-img">
                        <img src={
                          getProductImage(cat) ||
                          FALLBACK_IMAGE
                        }
                          alt={
                            cat.categoryName
                          }
                          onError={
                            handleImageError
                          } />
                      </div>
                      <h3 className="cate-title">
                        <Link
                          to={`/shop/category/${cat.categoryID}`}
                        >
                          {cat.categoryName}
                        </Link>
                      </h3>
                      <span className="cate-stock"> {cat.productCount || 0} product</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
